import React from 'react';
import { Button } from "antd";
import { AudioOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import './FloatingVoiceButton.css';

const FloatingVoiceButton = ({
    onClick,
    isActive,
    status = 'idle',
    isInitializing = false
}) => {
    const { t } = useTranslation("qr");

    const getTooltipText = () => {
        if (isInitializing) return `⏳ ${t("voice_initializing")}`;
        if (!isActive) return `🎤 ${t("voice_tap_to_start")}`;

        switch (status) {
            case 'listening':
                return `🎤 ${t("voice_listening")}`;
            case 'speaking':
                return `🔊 ${t("voice_speaking")}`;
            case 'item-added':
                return `✅ ${t("voice_added_to_cart")}`;
            case 'item-removed':
                return `🗑️ ${t("voice_removed")}`;
            case 'order-placed':
                return `🎉 ${t("voice_order_placed")}`;
            default:
                return `🎤 ${t("voice_active")}`;
        }
    };

    const getStatusClass = () => {
        if (isInitializing) return 'initializing';
        if (!isActive) return '';

        switch (status) {
            case 'listening':
                return 'listening';
            case 'speaking':
                return 'speaking';
            case 'item-added':
                return 'success';
            case 'item-removed':
                return 'removed';
            case 'order-placed':
                return 'order-success';
            default:
                return '';
        }
    };

    return (
        <div className="floating-voice-button-container">
            {/* Always visible tooltip above button */}
            {(isActive || isInitializing) && (
                <div className="status-tooltip visible">{getTooltipText()}</div>
            )}

            <Button type="primary"
                className={`floating-voice-button ${isActive ? 'active' : ''} ${getStatusClass()}`}
                onClick={isInitializing ? undefined : onClick}
                disabled={isInitializing}
                aria-label={t("voice_assistant")}
             htmlType="button">
                {isInitializing ? (
                    <span className="loading-spinner">⏳</span>
                ) : (
                    <AudioOutlined className="icon" />
                )}
            </Button>

            {/* Pulse rings overlay the button from OUTSIDE it, so the button's
                only child is the icon and its centering never shifts. */}
            {isActive && !isInitializing && (
                <>
                    <span className="pulse-ring"></span>
                    <span className="pulse-ring-2"></span>
                </>
            )}

            {!isActive && !isInitializing && (
                <div className="tooltip">{getTooltipText()}</div>
            )}
        </div>
    );
};

export default FloatingVoiceButton;
